import React from 'react';
import PropTypes from 'prop-types';

import { TableRow as MuiTableRow } from '@material-ui/core';

const TableRow = ({ children, ...rest }) => {
  return (
    <MuiTableRow
      {...rest}
    >
      { children }
    </MuiTableRow>
  )
}

TableRow.defaultProps = {
  children: null,
};

TableRow.propTypes = {
  children: PropTypes.node,
};

export default TableRow;



// WEBPACK FOOTER //
// ./src/components/base/TableRow/TableRow.js